import React, { useEffect, useRef, useState } from "react";
import CodeSnippet from "./CodeSnippet";
import { BACKEND_URL } from "../config";

/** eslint-disable */
const ASSET_NETWORK_OPTIONS = [
  {
    symbol: "USDC",
    network: "Arbitrum",
    label: "USDC (Arbitrum)",
    networkId: "arbitrum",
  },
  {
    symbol: "USDC",
    network: "Arbitrum Goerli",
    label: "USDC (Arbitrum Goerli)",
    networkId: "arbitrumGoerli",
  },
  {
    symbol: "USDC",
    network: "Avalanche",
    label: "USDC (Avalanche)",
    networkId: "avalanche",
  },
  {
    symbol: "USDC",
    network: "Avalanche Fuji",
    label: "USDC (Avalanche Fuji)",
    networkId: "avalancheFuji",
  },
  { symbol: "USDC", network: "Base", label: "USDC (Base)", networkId: "base" },
  {
    symbol: "USDC",
    network: "Base Sepolia",
    label: "USDC (Base Sepolia)",
    networkId: "baseSepolia",
  },
  {
    symbol: "USDC",
    network: "Ethereum",
    label: "USDC (Ethereum)",
    networkId: "ethereum",
  },
  {
    symbol: "USDC",
    network: "Ethereum Goerli",
    label: "USDC (Ethereum Goerli)",
    networkId: "ethereumGoerli",
  },
  {
    symbol: "USDC",
    network: "Ethereum Sepolia",
    label: "USDC (Ethereum Sepolia)",
    networkId: "ethereumSepolia",
  },
  {
    symbol: "USDC",
    network: "Optimism",
    label: "USDC (Optimism)",
    networkId: "optimism",
  },
  {
    symbol: "USDC",
    network: "Optimism Goerli",
    label: "USDC (Optimism Goerli)",
    networkId: "optimismGoerli",
  },
  {
    symbol: "USDC",
    network: "Polygon",
    label: "USDC (Polygon)",
    networkId: "polygon",
  },
  {
    symbol: "USDC",
    network: "Polygon Mumbai",
    label: "USDC (Polygon Mumbai)",
    networkId: "polygonMumbai",
  },
  {
    symbol: "USDC",
    network: "Solana",
    label: "USDC (Solana)",
    networkId: "solana",
  },
  {
    symbol: "USDC",
    network: "Solana Devnet",
    label: "USDC (Solana Devnet)",
    networkId: "solanaDevnet",
  },
  {
    symbol: "Stellar",
    network: "Stellar",
    label: "XLM (Stellar)",
    networkId: "stellar",
  },
  {
    symbol: "Stellar",
    network: "Stellar Testnet",
    label: "XLM (Stellar Testnet)",
    networkId: "stellarTestnet",
  },
  {
    symbol: "ALGO",
    network: "Algorand",
    label: "ALGO (Algorand)",
    networkId: "algorand",
  },
  {
    symbol: "ALGO",
    network: "Algorand Testnet",
    label: "ALGO (Algorand Testnet)",
    networkId: "algorandTestnet",
  },
  {
    symbol: "AVAX",
    network: "Avalanche",
    label: "AVAX (Avalanche)",
    networkId: "avalanche",
  },
  {
    symbol: "AVAX",
    network: "Avalanche Fuji",
    label: "AVAX (Avalanche Fuji)",
    networkId: "avalancheFuji",
  },
  {
    symbol: "BTC",
    network: "Bitcoin",
    label: "BTC (Bitcoin)",
    networkId: "bitcoin",
  },
  {
    symbol: "BTC",
    network: "Bitcoin Testnet",
    label: "BTC (Bitcoin Testnet)",
    networkId: "bitcoinTestnet",
  },
  {
    symbol: "DOGE",
    network: "Dogecoin",
    label: "DOGE (Dogecoin)",
    networkId: "dogecoin",
  },
  {
    symbol: "DOGE",
    network: "Dogecoin Testnet",
    label: "DOGE (Dogecoin Testnet)",
    networkId: "dogecoinTestnet",
  },
  {
    symbol: "ETH",
    network: "Ethereum",
    label: "ETH (Ethereum)",
    networkId: "ethereum",
  },
  {
    symbol: "ETH",
    network: "Ethereum Goerli",
    label: "ETH (Ethereum Goerli)",
    networkId: "ethereumGoerli",
  },
  {
    symbol: "ETH",
    network: "Ethereum Sepolia",
    label: "ETH (Ethereum Sepolia)",
    networkId: "ethereumSepolia",
  },
  {
    symbol: "OP",
    network: "Optimism",
    label: "OP (Optimism)",
    networkId: "optimism",
  },
  {
    symbol: "OP",
    network: "Optimism Goerli",
    label: "OP (Optimism Goerli)",
    networkId: "optimismGoerli",
  },
  {
    symbol: "MATIC",
    network: "Ethereum",
    label: "MATIC (Ethereum)",
    networkId: "ethereum",
  },
  {
    symbol: "MATIC",
    network: "Ethereum Goerli",
    label: "MATIC (Ethereum Goerli)",
    networkId: "ethereumGoerli",
  },
  {
    symbol: "MATIC",
    network: "Polygon",
    label: "MATIC (Polygon)",
    networkId: "polygon",
  },
  {
    symbol: "MATIC",
    network: "Polygon Mumbai",
    label: "MATIC (Polygon Mumbai)",
    networkId: "polygonMumbai",
  },
  {
    symbol: "XRP",
    network: "Ripple",
    label: "XRP (Ripple)",
    networkId: "ripple",
  },
  {
    symbol: "XRP",
    network: "Ripple Testnet",
    label: "XRP (Ripple Testnet)",
    networkId: "rippleTestnet",
  },
  {
    symbol: "SOL",
    network: "Solana",
    label: "SOL (Solana)",
    networkId: "solana",
  },
  {
    symbol: "SOL",
    network: "Solana Devnet",
    label: "SOL (Solana Devnet)",
    networkId: "solanaDevnet",
  },
  { symbol: "XTZ", network: "Tezos", label: "XTZ (Tezos)", networkId: "tezos" },
  {
    symbol: "XTZ",
    network: "Tezos Testnet",
    label: "XTZ (Tezos Testnet)",
    networkId: "tezosTestnet",
  },
  {
    symbol: "ARB",
    network: "Arbitrum",
    label: "ARB (Arbitrum)",
    networkId: "arbitrum",
  },
  {
    symbol: "ARB",
    network: "Arbitrum Goerli",
    label: "ARB (Arbitrum Goerli)",
    networkId: "arbitrumGoerli",
  },
];

const DEMO_USER_ID = "user-jane-doe-456";
const DEMO_BEARER_TOKEN_DESC = "YOUR_PLATFORM_BEARER_TOKEN";

function App() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loading, setLoading] = useState(false);
  const [apiRequestResponse, setApiRequestResponse] = useState<any>(null);
  const [widgetError, setWidgetError] = useState<any>(null);
  const [linkedAccountId, setLinkedAccountId] = useState<string | null>(null);

  // Trade form state
  const [externalAccountId, setExternalAccountId] = useState("");
  const [amount, setAmount] = useState("1");
  const [destinationSymbol, setDestinationSymbol] = useState("ETH");
  const [destinationNetwork, setDestinationNetwork] =
    useState("ethereumSepolia");
  const [selectedAsset, setSelectedAsset] = useState("ETH|Ethereum Sepolia");

  // Hardcoded values for simulation
  const SERVER = BACKEND_URL; // Change as needed

  async function simulateWireDepositAndTrade(
    e: React.FormEvent<HTMLFormElement>,
  ) {
    e.preventDefault();
    setLoading(true);
    setApiRequestResponse(null);

    const requestUrl = `${SERVER}/smb/test-transaction`;
    const requestBody = {
      source: {
        externalAccountId,
        amount,
      },
      destination: {
        symbol: destinationSymbol,
        network: destinationNetwork,
      },
    };

    const requestDetails = {
      url: requestUrl,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    };

    setApiRequestResponse({ request: requestDetails });

    try {
      const response = await fetch(requestUrl, {
        method: "POST",
        headers: requestDetails.headers,
        body: JSON.stringify(requestBody),
      });

      const responseBody = await response.json();

      setApiRequestResponse((prev: any) => ({
        ...prev,
        response: {
          status: response.status,
          statusText: response.statusText,
          body: responseBody,
        },
      }));

      if (!response.ok) {
        const errorDetail =
          responseBody.message || JSON.stringify(responseBody);
        throw new Error(
          `HTTP error! status: ${response.status}, message: ${errorDetail}`,
        );
      }
    } catch (err: any) {
      setApiRequestResponse((prev: any) => ({
        ...prev,
        error: err.message,
      }));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      console.log("Received message from widget:", event.data);
      if (event.data && event.data.event === "bankLinked") {
        setLinkedAccountId(event.data.externalAccountId);
        setExternalAccountId(event.data.externalAccountId);
        setWidgetError(null);
      }
      if (event.data && event.data.event === "bankLinkFailed") {
        setLinkedAccountId(null);
        setWidgetError(event.data.error);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const WIDGET_URL = `${SERVER}/smb/test-bec`;

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        background: "#f3f4f6",
        minHeight: "100vh",
        padding: "2em",
      }}
    >
      <h1>Sample B2B2C Platform: Parent App Demo</h1>
      <p style={{ maxWidth: 600 }}>
        This is a sample B2B2C platform. The <b>Parent Platform</b> (this app)
        embeds a <b>Plaid Widget</b> for its end customers to link their bank
        accounts. After linking, the platform can simulate a wire deposit and
        trade on behalf of the customer.
      </p>
      <hr style={{ margin: "2em 0" }} />

      <section style={{ marginBottom: "2em" }}>
        <h2>Customer Info</h2>
        <div
          style={{
            background: "#fff",
            padding: "1em",
            borderRadius: 6,
            boxShadow: "0 1px 3px #0001",
            maxWidth: 400,
          }}
        >
          <div>
            <b>Customer Name:</b> Jane Doe
          </div>
          <div>
            <b>User ID:</b> {DEMO_USER_ID} (Hardcoded for demo)
          </div>
        </div>
      </section>

      <hr style={{ margin: "2em 0" }} />

      <section style={{ marginBottom: "2em" }}>
        <h2>1. Fetch and Embed Plaid Widget</h2>
        <p style={{ color: "#555", marginBottom: 8, maxWidth: 600 }}>
          Your platform makes an API request to get an iframe that displays a
          secure widget. This lets customers safely connect their bank account,
          creating a direct link between their bank and your platform. For this
          demo, we use test data to show how it works.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(500px, 1fr))",
            gap: "2em",
            alignItems: "start",
          }}
        >
          <div>
            <p style={{ color: "#555", marginBottom: 8 }}>
              The widget below is what your end customer would use to link their
              bank account.
            </p>
            <iframe
              ref={iframeRef}
              src={WIDGET_URL}
              width={520}
              height={600}
              style={{
                border: "1px solid #ccc",
                borderRadius: 8,
                background: "#fff",
              }}
              title="Plaid Widget"
            />
          </div>
          <div>
            <CodeSnippet
              title="Example Request: Get Widget HTML"
              code={`// Your backend makes this GET request to fetch the widget content.
// Optional query parameters can be appended for styling.

const url = 'http://localhost:8001/smb/bec?userId=${DEMO_USER_ID}&buttonColor=4caf50&cornerRadius=lg';

/*
Optional Styling Parameters (as query params):
- buttonColor: (string) Hex color code for primary buttons (e.g., '4caf50').
- cornerRadius: (string) 'sm', 'md', 'lg', 'xl', 'full'.
- viewportWidth: (string) A number representing the viewport width in pixels.
*/

const response = await fetch(url, {
  method: 'GET',
  headers: {
    // IMPORTANT: Store and use your token securely on the backend.
    'Authorization': 'Bearer ${DEMO_BEARER_TOKEN_DESC}'
  }
});

const widgetHtml = await response.text();
// Your backend then serves this HTML, which is rendered in the iframe.`}
            />
            {linkedAccountId && (
              <div
                style={{
                  marginTop: "1em",
                  background: "#e8f5e9",
                  padding: "1em",
                  borderRadius: 6,
                  maxWidth: 520,
                  boxSizing: "border-box",
                }}
              >
                <p
                  style={{
                    color: "green",
                    fontWeight: "bold",
                    margin: "0 0 0.5em 0",
                  }}
                >
                  ✓ Bank account linked successfully!
                </p>
                <p
                  style={{
                    margin: "0 0 1em 0",
                    color: "#333",
                    fontSize: "14px",
                  }}
                >
                  The External Account ID has been auto-filled in the form
                  below. You can also copy it from here:
                </p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="text"
                    readOnly
                    value={linkedAccountId}
                    style={{
                      fontFamily: "monospace",
                      flexGrow: 1,
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      padding: "0.5em",
                      background: "#fff",
                    }}
                    onClick={(e: React.MouseEvent<HTMLInputElement>) =>
                      (e.target as HTMLInputElement).select()
                    }
                  />
                  <button
                    onClick={() =>
                      navigator.clipboard.writeText(linkedAccountId)
                    }
                    style={{
                      marginLeft: "1em",
                      background: "#4caf50",
                      color: "white",
                      border: "none",
                      padding: "0.6em 1em",
                      borderRadius: 4,
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
            )}
            {widgetError && (
              <div style={{ marginTop: "1em", color: "red" }}>
                <strong>Plaid Widget Error:</strong>
                <pre
                  style={{
                    background: "#ffebee",
                    padding: "1em",
                    marginTop: "0.5em",
                    borderRadius: 6,
                    color: "#c62828",
                    maxWidth: 520,
                    boxSizing: "border-box",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                  }}
                >
                  {JSON.stringify(widgetError, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </div>
      </section>

      <hr style={{ margin: "2em 0" }} />

      <section style={{ marginBottom: "2em" }}>
        <h2>2. Fiat Deposit & Trade Simulation</h2>
        <p style={{ color: "#555", marginBottom: 8 }}>
          After the customer links their bank, the platform can initiate a fiat
          deposit and simulate a trade on their behalf.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(500px, 1fr))",
            gap: "2em",
            alignItems: "start",
          }}
        >
          <div>
            <form
              onSubmit={simulateWireDepositAndTrade}
              style={{
                background: "#fff",
                padding: 16,
                borderRadius: 6,
                maxWidth: 500,
                marginBottom: 16,
              }}
            >
              <div style={{ marginBottom: 12 }}>
                <label>
                  External Account ID:
                  <input
                    type="text"
                    value={externalAccountId}
                    onChange={(e) => setExternalAccountId(e.target.value)}
                    style={{ marginLeft: 8, width: 320 }}
                    required
                  />
                </label>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label>
                  Amount (in $USD):
                  <input
                    type="number"
                    min="0.0001"
                    step="any"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    style={{ marginLeft: 8, width: 120 }}
                    required
                  />
                  <span style={{ marginLeft: 8, color: "#888", fontSize: 13 }}>
                    (ACH deposit in US Dollars)
                  </span>
                </label>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label>
                  Destination Asset:
                  <select
                    value={selectedAsset}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setSelectedAsset(selectedValue);
                      const [symbol, network] = selectedValue.split("|");
                      const selectedOption = ASSET_NETWORK_OPTIONS.find(
                        (opt) =>
                          opt.symbol === symbol && opt.network === network,
                      );
                      if (selectedOption) {
                        setDestinationSymbol(selectedOption.symbol);
                        setDestinationNetwork(selectedOption.networkId);
                      }
                    }}
                    style={{ marginLeft: 8, width: 260 }}
                  >
                    {ASSET_NETWORK_OPTIONS.map((opt) => (
                      <option
                        key={opt.symbol + opt.network}
                        value={`${opt.symbol}|${opt.network}`}
                      >
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <button
                type="submit"
                disabled={loading || !externalAccountId}
                className="rounded-md bg-green-500 px-6 py-3 font-bold text-white hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-slate-400"
              >
                {loading
                  ? "Processing..."
                  : "Submit Fiat Deposit & Simulate Trade"}
              </button>
            </form>
          </div>
          <div style={{ marginTop: 16 }}>
            <CodeSnippet
              title="Example Request: Create Fiat Deposit"
              code={`// Your backend makes this POST request to initiate the fiat deposit.

const url = 'http://localhost:8001/smb/users/${DEMO_USER_ID}/transactions/deposits/fiat';

const body = {
  "source": {
    "externalAccountId": "acc_123abc456def789", // From the widget linking step
    "amount": "1.00"
  },
  "destination": {
    "symbol": "ETH",
    "network": "ethereumSepolia"
  }
};

const response = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ${DEMO_BEARER_TOKEN_DESC}'
  },
  body: JSON.stringify(body)
});

const data = await response.json();
console.log('API Response:', data);`}
            />
            {loading && (
              <div style={{ color: "#555", marginTop: "1em" }}>
                Processing...
              </div>
            )}
            {apiRequestResponse?.response && (
              <CodeSnippet
                title={`Live API Response (${apiRequestResponse.response.status})`}
                code={JSON.stringify(apiRequestResponse.response.body, null, 2)}
              />
            )}
            {apiRequestResponse?.error && !apiRequestResponse?.response && (
              <CodeSnippet title="API Error" code={apiRequestResponse.error} />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
